export const INTERACTIVE_SPQ_LIST = 'INTERACTIVE_SPQ_LIST';
